<mat-dialog-content>
  <lemon-dialog-header> Maksutavan {{ data.maksutapa.nimi }} historia </lemon-dialog-header>
  @if (loading()) {
    <div style="text-align: center; padding: 20px">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!loading() && historia().length === 0) {
    <div style="padding: 20px; text-align: center; color: #666">Ei historiatietoja</div>
  }

  @if (!loading() && historia().length > 0) {
    <table style="width: 100%; border-collapse: collapse">
      <thead>
        <tr style="border-bottom: 2px solid #ddd; background-color: #f5f5f5">
          <th style="padding: 12px; text-align: left">Päivitetty</th>
          <th style="padding: 12px; text-align: left">Päivitti</th>
          <th style="padding: 12px; text-align: left">Nimi</th>
          <th style="padding: 12px; text-align: left">Kirjauksien muodostus</th>
          <th style="padding: 12px; text-align: left">Tilinumero</th>
          <th style="padding: 12px; text-align: left">Vastakirjaus</th>
          <th style="padding: 12px; text-align: left">Voimassa alkaen</th>
          <th style="padding: 12px; text-align: left">Voimassa loppuen</th>
        </tr>
      </thead>
      <tbody>
        @for (item of historia(); track item) {
          <tr style="border-bottom: 1px solid #eee">
            <td style="padding: 12px">{{ item.paivitetty.toDate() | date: 'dd.MM.yyyy HH:mm' }}</td>
            <td style="padding: 12px">{{ item.paivittajanNimi }}</td>
            <td style="padding: 12px">{{ item.nimi }}</td>
            <td style="padding: 12px">{{ item.tyypinNimi || '-' }}</td>
            <td style="padding: 12px">{{ item.sahkoisenTiliotteenTunniste || '-' }}</td>
            <td style="padding: 12px">{{ item.oletusVastatili || '-' }}</td>
            <td style="padding: 12px">{{ (item.tilitapahtumatSynkronoidaanAlkaen | lokaalipvml: 'fi') || '-' }}</td>
            <td style="padding: 12px">{{ (item.tilitapahtumatSynkronoidaanLoppuen | lokaalipvml: 'fi') || '-' }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button class="primarybutton" (click)="close()">Sulje</button>
</mat-dialog-actions>
